import { useTheme } from "@mui/material";
import { CarPortfolioChartItem } from "@app/pages/assetAllocation/asset-allocation-types";
import {
  CarPdfHeader,
  CarPdfHeaderCell,
  CarPdfRow,
  CarPdfTable,
  CarPdfTableProps,
  CarPdfTextCell,
} from "@app/components/PdfTable";
import {
  ExcelDataFormat,
  excelTableFormatValue,
} from "@app/hooks/useExcelExport";
import { CarGicsReport } from "@app/hooks/useGics";
import { getSectorAnalysisSummaryExcelTable } from "../AssetClassAnalysisSectorAnalysisTable";

interface SectorAnalysisSummaryPdfTableProps
  extends Omit<CarPdfTableProps, "children" | "collWidths"> {
  data: CarPortfolioChartItem[];
  report: CarGicsReport;
  data1Id: string;
  data2Id: string;
}

export const SectorAnalysisSummaryPdfTable = ({
  data,
  report,
  data1Id,
  data2Id,
  ...props
}: SectorAnalysisSummaryPdfTableProps) => {
  const theme = useTheme();

  const table = getSectorAnalysisSummaryExcelTable({
    data,
    report,
    data1Id,
    data2Id,
  });

  return (
    <CarPdfTable
      colWidths={table.columns.map((i, idx) => (idx === 0 ? 1.3 : 1))}
      isRounded
      isStriped
      {...props}
    >
      <CarPdfHeader paddingVertical={8} key="label">
        {table.columns.map((i, idx) => (
          <CarPdfHeaderCell key={idx}>{i.label}</CarPdfHeaderCell>
        ))}
      </CarPdfHeader>
      {table.rows.map((row, rowIdx) => (
        <CarPdfRow key={rowIdx} paddingVertical={8}>
          {row.map((value, valueIdx) => (
            <CarPdfTextCell
              key="label"
              style={{
                textAlign:
                  table.columns[valueIdx].format === ExcelDataFormat.general
                    ? "left"
                    : "center",
                paddingHorizontal: 15,
              }}
            >
              {excelTableFormatValue(value, table.columns[valueIdx])}
            </CarPdfTextCell>
          ))}
        </CarPdfRow>
      ))}
    </CarPdfTable>
  );
};
